import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './tube.css';
import MessageBox from 'containers/App/components/MessageBox';
import MessageForm from 'containers/App/components/MessageForm';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTokenRefresh } from '@mayo/login-pass';
import { SECURITY_API_SERVER } from 'configs/url';
class Tube extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        {
          (() => {
            if (this.props.message.message) {
              return (
                <MessageBox
                  width={250}
                  onClose={this.props.message.onClose}
                  title={<FormattedMessage id="SH_Message" defaultMessage="訊息" />}
                >
                  <MessageForm
                    onConfirm={this.props.message.onConfirm}
                    MessageText={this.props.message.message}
                    onCancel={this.props.message.onCancel}
                  />
                </MessageBox>
              );
            }
          })()
        }
        {this.props.children}
      </div>
    );
  }
}
Tube.propTypes = {
  message: PropTypes.object,
  children: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  return {
    message: state.app.tube.message,
  };
}

export default compose(
  withTokenRefresh({ baseURL: SECURITY_API_SERVER }),
  connect(mapStateToProps)
)(Tube);



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Tube/index.js
 **/